import { getAccessToken } from "../auth/authClient";
import type {
  CreateTemplateResponse,
  TemplateDetail,
  TemplateSummary,
} from "../types";

const API_URL = import.meta.env.VITE_API_URL;
if (!API_URL) throw new Error("Falta VITE_API_URL");

async function authedFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = await getAccessToken();
  if (!token) throw new Error("Sesión expirada");
  const resp = await fetch(`${API_URL}${path}`, {
    ...init,
    headers: {
      ...(init.headers ?? {}),
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!resp.ok) {
    const body = await resp.text();
    throw new Error(`${resp.status} ${resp.statusText}: ${body}`);
  }
  return resp;
}

export async function createTemplate(
  name: string,
  html: string,
  subject = "{{subject}}",
  preheader: string | null = null,
): Promise<CreateTemplateResponse> {
  const resp = await authedFetch("/api/templates", {
    method: "POST",
    body: JSON.stringify({ name, html, subject, preheader }),
  });
  return resp.json();
}

export async function listTemplates(): Promise<TemplateSummary[]> {
  const resp = await authedFetch("/api/templates");
  const data = await resp.json();
  return data.templates ?? [];
}

export async function getTemplate(id: string): Promise<TemplateDetail> {
  const resp = await authedFetch(`/api/templates/${id}`);
  return resp.json();
}
